import PropTypes from 'prop-types'

import { Columns, LoadingModule } from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'

import PageLayout from '../../../../components/PageLayout'

import BrandInactiveBanner from '../../../../components/BrandInactiveBanner'
import CustomFieldSets from '../CustomFieldSets'

const PageContent = (props) => {
  const { brandId } = props

  const brandPayload = useBrand({ id: brandId })
  const { brand, loading } = brandPayload

  return (
    <PageLayout activeTabBarItemKey="customFields" entityPayload={brandPayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {brand.hidden && (
          <BrandInactiveBanner brandPayload={brandPayload} />
        )}

        {!loading && (
          <CustomFieldSets brandId={brandId} />
        )}
      </Columns.Main>
    </PageLayout>
  )
}

PageContent.propTypes = {
  brandId: PropTypes.number.isRequired,
}

export default PageContent
